(ns manatee.models.item
  (:require [manatee.domain.edit :as edit]
            [rothko.editor.matcher :as m]))

(defmulti reject (fn [item & _] (m/dispatch reject item)))
(defmulti annotation-view (fn [item & _] (:view-state item)))
(defmulti metadata-options (fn [item & _] (m/dispatch metadata-options item)))

(defn edit-or-item-val
  [key item]
  (get-in item [:edit key] (get item key)))

(defn appropriate-script
  [answer field-name]
  (if (and (:feedback? answer) (-> answer :feedback :edit field-name))
    (-> (edit-or-item-val field-name (:feedback answer))
        edit/coerce-script)
    (edit-or-item-val field-name answer)))

(defn appropriate-edit
  [edit item field-name]
  (or (-> item :feedback :edit field-name)
      (-> edit field-name)))
